<div *ngIf="visible" class="alert alert-warning">
  <div class="titlebar">
    <span class="env">
      <ng-container *ngIf="environment === 'staging'">
        Staging
      </ng-container>
      <ng-container *ngIf="environment === 'development'">
        Development
      </ng-container>
    </span>
    <span class="title" *ngIf="title">
      &raquo;
      {{ title }}
    </span>
    <div class="spacer"></div>
    <a class="close" href="javascript:;" (click)="remove()">
      <mat-icon>close</mat-icon>
    </a>
  </div>
  <div *ngIf="!shown">
    <a href="javascript:;" (click)="shown = true">Show Details</a>
  </div>
  <div class="content-container" [class.visible]="shown">
    <ng-content></ng-content>
  </div>
</div>